<template>
  <validation-provider
    #default="{ errors }"
    name="supplier"
    :rules="{
      required: requiredField,
    }"
  >
    <b-form-group
      label="Fornecedor"
      label-for="supplier"
    >
      <vue-autosuggest
        v-model="supplierSearch"
        no-filter
        :suggestions="suppliersOptions"
        :input-props="{
          id: 'supplier',
          ref: 'supplier',
          class: errors.length > 0 ? 'form-control is-invalid' : 'form-control',
          placeholder: readonly ? '' : 'Fornecedor',
          readonly: readonly,
        }"
        :limit="limitElements"
        :class="errors.length > 0 ? 'error-select' : ''"
        :get-suggestion-value="getSupplierSelected"
        @input="onInputSupplierChange"
        @selected="onSelectedSupplier"
        @blur="onBlur"
      >
        <template slot-scope="{suggestion}">
          <p>{{ suggestion.item.name }}</p>
        </template>
      </vue-autosuggest>
      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>
<script>

import {
  VueAutosuggest,
} from 'vue-autosuggest'

import {
  BFormGroup,
} from 'bootstrap-vue'

import {
  ValidationProvider,
} from 'vee-validate'

import {
  required,
} from '@validations'

import {
  useToast,
} from 'vue-toastification/composition'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import syslic from '@/syslic'

export default {
  components: {
    BFormGroup,
    VueAutosuggest,
    ValidationProvider,
  },
  model: {
    prop: 'supplierValue',
    event: 'supplierChange',
  },
  props: {
    supplierValue: {
      type: [Object, String],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
    requiredField: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const suppliersOptions = []
    return {
      limitElements: 20,
      suppliersOptions,
      required,
      supplierSearch: '',
    }
  },
  computed: {
    supplier: {
      get() {
        return this.supplierValue
      },
      set(value) {
        this.$emit('supplierChange', value)
      },
    },
  },
  watch: {
    supplierValue: function updateSupplier(supplier) {
      if (supplier) {
        this.supplierSearch = this.getSupplierSelected({ item: supplier })
      } else {
        this.supplierSearch = ''
      }
    },
  },
  created() {
    this.$emit('ready', true)
  },
  methods: {
    onSelectedSupplier(selected) {
      if (selected === '' || selected === undefined) {
        return
      }
      this.supplier = selected.item
    },
    getSupplierSelected(suggestion) {
      return `${suggestion.item.name}`
    },
    onInputSupplierChange(text) {
      syslic
        .supplier
        .fetchSupplierList({
          search: text,
          p: 1,
          page_size: this.limitElements,
        })
        .then(response => {
          this.suppliersOptions = [{
            data: response.data.results,
          }]
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao ler os dados.',
              text: 'Não foi possível ler os dados do servidor, por favor entre em contato com o administrador do sistema.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
        })
    },
    onBlur() {
      if (this.supplier) {
        const supplierSelected = this.getSupplierSelected({ item: this.supplier })
        if (this.supplierSearch !== supplierSelected) {
          this.supplier = ''
        }
      } else {
        this.supplierSearch = ''
      }
    },
  },
  setup() {
    const toast = useToast()

    return {
      toast,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
</style>
